
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"22","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11 3c1.654 0 3 1.348 3 3 0 1.657-1.346 3-3 3S8 7.657 8 6c0-1.652 1.346-3 3-3zm5 3c0-2.757-2.243-5-5-5S6 3.243 6 6s2.243 5 5 5 5-2.243 5-5zm2 14H4v-3.242c0-.82.34-1.621.91-2.148.292-.27.772-.596 1.458-.577.378.009 1.549-.005 2.973-.01 2.127-.009 4.81-.023 6.2-.023C17.23 14 18 15.3 18 16.506V20zm-8.768-7.974c-1.5.006-2.739.011-3.125.011H6.1c-.974-.016-1.922.376-2.663 1.112-.9.89-1.438 2.225-1.438 3.576v4.48c0 .435.352.795.786.795h16.428c.434 0 .786-.36.786-.794v-4.767C20 14.289 18.534 12 15.817 12c-1.474 0-4.325.016-6.585.026z","fill":"#8E8E92","fill-rule":"evenodd"}})])
          )
        }
      }
    